
import React from "react";

/**
 * Stopka aplikacji
 */
export const Footer = () => {
    return (
        <div className="w3-center w3-black w3-padding footer">
            v. {process.env.REACT_APP_VERSION}
        </div>
    )
}